<template>
    <h1
        :class="classStyles['text-secondary_color-500']"
        class="text-3xl md:text-4xl"
    >
        <slot/>
    </h1>
</template>

<script>
export default {
  name: 'BaseH1',
  data () {
    return {
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
